<template>
  <section>
    <div class="local-lm-filters">
      <b-field
        class="lm-label"
      >
        <b-input
          v-model.trim="orderBo"
          type="text"
          :placeholder="$t('OrderFilter.labelBoPlaceholder')"
          class="local-lm-filters--input"
          :disabled="flag"
          @input="sendOrderBo"
        />
      </b-field>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OrderBoFilter',
  computed: {
    flag () {
      return this.$attrs.hasDisableBo
    }
  },
  data () {
    return {
      orderBo: null
    }
  },
  mounted () {
    this.$eventBus.$on('cleanFilters', () => {
      this.orderBo = null
    })
  },
  methods: {
    sendOrderBo () {
      const flag = !!(this.orderBo) || false
      this.$store.dispatch('filters/setOrderBoSelected', this.orderBo)
      this.$eventBus.$emit('orderBoWrite', flag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderBoFilter.vue